import {mutation, query, proxy_api} from "@core/helpers/graphql";
import {GET_BLOG_BY_SLUG, GET_BLOGS, GET_FAVORITE_BLOGS, GET_SEARCH_BLOGS} from "./_queries";
import {ADD_BLOG_TO_FAVORITES} from "./_mutations";

export const get_blog_by_slug = async (variables, options = {}) => {
	const {gql,blog_mockup} = options;
	const result = await query(gql || GET_BLOG_BY_SLUG(blog_mockup), variables, options);

	return {
		data: result?.data,
		errors: result?.errors || false,
		status: result?.status || false,
	};
};

export const get_blog_by_slug_proxy = async (variables, options = {}) => {
	const {gql,blog_mockup} = options;

	const result = await proxy_api({
		type: 'query',
		gql: gql || GET_BLOG_BY_SLUG(blog_mockup),
		variables,
		options,
		cacheOptions: {
			name: 'single-blog',
			ttl: 60 * 5,
			keys: variables
		}
	});

	return {
		data: result?.data,
		errors: result?.errors || false,
		status: result?.status || false,
	};
};


export const get_blogs_query = async (variables, options = {}) => {
	const {gql, blog_card_mockup} = options;
	const result = await query(
		gql || GET_BLOGS({blog_card_mockup}),
		variables,
		options
	);
	return {
		data: result?.data,
		errors: result?.errors || false,
		status: result?.status || false,
	};
};

export const get_blogs_query_proxy = async (variables, options = {}) => {
	const {gql, blog_card_mockup} = options;

	const result = await proxy_api({
		type: 'query',
		gql: gql || GET_BLOGS({blog_card_mockup}),
		variables,
		options,
		cacheOptions: {
			name: 'blogs',
			ttl: 60 * 5,
			keys: variables
		}
	});

	return {
		data: result?.data,
		errors: result?.errors || false,
		status: result?.status || false,
	};
};

export const add_blog_to_favorites_mutation = async (
	variables,
	options = {}
) => {
	const {gql} = options;
	const result = await mutation(
		gql || ADD_BLOG_TO_FAVORITES,
		variables,
		options
	);
	return {
		data: result?.data,
		errors: result?.errors || false,
		status: result?.status || false,
	};
};

export const get_search_blogs_query = async (variables, options = {}) => {
	const {gql, blog_card_mockup, category_card_mockup} = options;

	const result = await query(
		gql || GET_SEARCH_BLOGS({blog_card_mockup, category_card_mockup}),
		variables,
		options
	);
	return {
		data: result?.data,
		errors: result?.errors || false,
		status: result?.status || false,
	};
};

export const get_favorite_blogs_query = async (variables, options = {}) => {
	const {gql, blog_card_mockup} = options;

	const result = await query(
		gql || GET_FAVORITE_BLOGS({blog_card_mockup}),
		variables,
		options
	);
	return {
		data: result?.data,
		errors: result?.errors || false,
		status: result?.status || false,
	};
};
